import { useState, useEffect } from "react";

/**
 * Returns a debounced value that updates after `delay` ms when `value` changes.
 * @param {*} value - Value to debounce
 * @param {number} delay - Delay in ms (default 300)
 * @returns {*} Debounced value
 */
export function useDebouncedValue(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
